<template>
  <div class="class-1">
    <AppHeader title="Add New Printer" />
    
    <div class="container mt-4">
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="submitForm">
            <!-- Printer ID Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="printer_id">Printer ID</label>
                <input
                  type="text"
                  class="form-control"
                  id="printer_id"
                  placeholder="Enter Printer ID"
                  v-model="form.printer_id"
                  required
                >
                <small class="form-text text-muted">
                  Required: Enter the printer identifier
                </small>
              </div>
            </div>

            <!-- Name Inputs for Each Language -->
            <div class="form-row" v-for="language in languages" :key="language.id">
              <div class="form-group col-md-12">
                <label :for="`name_${language.id}`">Name ({{ language.fullName }})</label>
                <input
                  type="text"
                  class="form-control"
                  :id="`name_${language.id}`"
                  :placeholder="`Enter Printer Name in ${language.fullName}`"
                  v-model="form.names[language.id]"
                  required
                >
              </div>
            </div>

            <!-- Buttons -->
            <div class="form-row">
              <div class="form-group col-12 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                <button type="submit" class="btn btn-primary">Add Printer</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: [],
      form: {
        printer_id: '',
        names: {}
      }
    };
  },
  mounted() {
    this.fetchLanguages();
  },
  methods: {
    fetchLanguages() {
      const storedLanguages = localStorage.getItem('languages');
      if (storedLanguages) {
        this.languages = JSON.parse(storedLanguages);
        // Initialize form names for each language
        this.languages.forEach(lang => {
          this.form.names[lang.id] = '';
        });
      }
    },
    async submitForm() {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        const branchId = localStorage.getItem('branchId');
        const payload = {
          printer_id: this.form.printer_id, // Renamed from server_id
          branchId: branchId,
          names: this.languages.map(language => ({
            langId: language.id,
            name: this.form.names[language.id] || ''
          }))
        };

        const response = await fetch(`${this.$BASE_API_URL}/api/printers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          this.$toast.success('Printer added successfully!');
          this.$router.push({ name: 'PrintersManagement' });
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to add printer');
        }
      } catch (error) {
        console.error('Error adding printer:', error);
        this.$toast.error(error.message || 'Failed to add printer');
      } finally {
        this.$root.isLoading = false;
      }
    },
    cancelForm() {
      this.$router.go(-1);
    }
  }
};
</script>